
import { useState, useEffect } from "react";

const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

let initialDocsByStatus = {};

// Applique les filtres aux données
export function applyFilters(
  data,
  filter,
  dateRangeFilter = null,
  parseCustomDate = null
) {
  if (!Array.isArray(data)) {
    console.warn(
      "Les données sont nulles ou non définies, un tableau vide sera retourné."
    );
    return [];
  }

  // Filtrage spécifique pour ModelsVideoCodage selon le client
  if (filter.client) {
    data = data
      .map((model) => {
        const filteredStatuses = model.docsByStatus
          .map((status) => {
            const filteredDocs = (status.docs || []).filter(
              (doc) => doc.ClientId === filter.client
            );

            if (filteredDocs.length === 0) return null;

            const validDates = filteredDocs
              .map((doc) => parseCustomDate?.(doc.LastUpdate))
              .filter((date) => date !== null && !isNaN(date));

            const oldestDocDate =
              validDates.length > 0
                ? validDates.reduce((oldest, current) =>
                    current < oldest ? current : oldest
                  )
                : null;

            return {
              ...status,
              docs: filteredDocs,
              docsCount: filteredDocs.length,
              oldestDocDate,
            };
          })
          .filter((status) => status !== null);

        if (filteredStatuses.length === 0) return null;

        return {
          ...model,
          docsByStatus: filteredStatuses,
        };
      })
      .filter((model) => model !== null);
  }

  data.forEach((item) => {
    if (!item.docsByStatus) {
      item.docsByStatus = [];
    }
    if (!initialDocsByStatus[item.ModelId]) {
      initialDocsByStatus[item.ModelId] = [...item.docsByStatus];
    } else if (!filter.client) {
      item.docsByStatus = [...initialDocsByStatus[item.ModelId]];
    }
  });

  return data
    .filter((item) =>
      filter.searchDoc
        ? item.FileName?.toLowerCase().includes(
            filter.searchDoc.toLowerCase()
          ) ||
          item.DocId?.toString()
            .toLowerCase()
            .includes(filter.searchDoc.toLowerCase())
        : true
    )
    .filter((item) =>
      filter.FinalCustomer
        ? item.FinalCustomer?.toLowerCase().includes(
            filter.FinalCustomer.toLowerCase()
          )
        : true
    )
    .filter((item) =>
      filter.Status
        ? item.Status?.toLowerCase().includes(filter.Status.toLowerCase())
        : true
    )
    .filter((item) =>
      filter.OldStatus
        ? item.OldStatus?.toLowerCase().includes(filter.OldStatus.toLowerCase())
        : true
    )
    .filter((item) => {
      if (
        filter.isvalid !== null &&
        filter.isvalid !== undefined &&
        filter.isvalid !== ""
      ) {
        if (item.isvalid === undefined || item.isvalid === null) return false;

        const filterValue = filter.isvalid === "true";

        return item.isvalid === filterValue;
      }
      return true;
    })
    .filter((item) =>
      filter.Complexite
        ? item.Complexite?.toLowerCase().includes(
            filter.Complexite.toLowerCase()
          )
        : true
    )
    .filter((item) => {
      if (!Array.isArray(item.docsByStatus)) {
        return false;
      }

      if (filter.statusFilter) {
        const filteredDocs = item.docsByStatus.filter(
          (status) =>
            status.status === filter.statusFilter && status.docsCount > 0
        );

        if (filteredDocs.length > 0) {
          item.docsByStatus = filteredDocs;
          return true;
        }

        return false;
      }

      return true;
    })
    .filter((item) =>
      filter.searchInstance
        ? item.sInstanceName
            ?.toLowerCase()
            .includes(filter.searchInstance.toLowerCase()) ||
          item.kInstanceId
            ?.toString()
            .toLowerCase()
            .includes(filter.searchInstance.toLowerCase())
        : true
    )
    .filter((item) => (filter.sStatus ? item.sStatus === filter.sStatus : true))
    .filter((item) =>
      filter.sFinalCustomer
        ? item.sFinalCustomer
            ?.toLowerCase()
            .includes(filter.sFinalCustomer.toLowerCase())
        : true
    )
    .filter((item) =>
      filter.ModelId
        ? item.ModelId?.toLowerCase().includes(filter.ModelId.toLowerCase())
        : true
    )
    .filter((item) => {
      for (let key in filter) {
        const filterValue = filter[key];

        if (
          filterValue !== null &&
          filterValue !== undefined &&
          filterValue !== ""
        ) {
          const itemValue = getNestedValue(item, key);

          if (itemValue === undefined) continue;

          if (typeof itemValue === "boolean") {
            if (itemValue !== (filterValue === "true")) return false;
          } else if (typeof filterValue === "string") {
            if (
              !itemValue
                .toString()
                .toLowerCase()
                .includes(filterValue.toLowerCase())
            ) {
              return false;
            }
          }
        }
      }

      return true;
    })
    .filter((item) => {
      if (
        !dateRangeFilter ||
        !parseCustomDate ||
        (!dateRangeFilter.fromDate && !dateRangeFilter.toDate)
      )
        return true;
      const creationDate = parseCustomDate(item.dCreationDate);
      if (dateRangeFilter.fromDate && dateRangeFilter.toDate) {
        return (
          creationDate >= dateRangeFilter.fromDate &&
          creationDate <= dateRangeFilter.toDate
        );
      }
      return true;
    });
}

// Met à jour le type de filtre
export function updateFilterType(filterType, setDateRangeFilter) {
  setDateRangeFilter((prevFilter) => ({
    ...prevFilter,
    filterType: filterType,
  }));
}

// Fonction pour filtrer les données en fonction du modèle sélectionné
export function filterByModel(data, filter) {
  if (!filter.sModelId) {
    return data;
  }

  const filteredData = data.filter((item) => {
    const shouldInclude = item.sModelId === filter.sModelId;
    return shouldInclude;
  });

  return filteredData;
}

// Permet de reset les filtres dans le localstorage et relance la page
export function handleResetFilters() {
  localStorage.clear();
  window.location.reload(false);
}



// pour gérer l'état (page, tri, filtres) dans localStorage
export function useLotsState() {
  const [currentPage, setCurrentPage] = useState(() => {
    try {
      const storedPage = localStorage.getItem("currentPage_lots");
      return storedPage ? parseInt(storedPage, 10) : 1;
    } catch {
      return 1;
    }
  });

  const [sortField, setSortField] = useState(() => {
    try {
      return localStorage.getItem("sortField_lots") || "dCreationDate";
    } catch {
      return "dCreationDate";
    }
  });

  const [sortOrder, setSortOrder] = useState(() => {
    try {
      return localStorage.getItem("sortOrder_lots") || "desc";
    } catch {
      return "desc";
    }
  });

  const [dateRangeFilter, setDateRangeFilter] = useState(() => {
    try {
      const storedDateFilter = localStorage.getItem("dateRangeFilter_lots");
      if (storedDateFilter) {
        const parsed = JSON.parse(storedDateFilter);
        return {
          ...parsed,
          fromDate: parsed.fromDate ? new Date(parsed.fromDate) : null,
          toDate: parsed.toDate ? new Date(parsed.toDate) : null,
        };
      }
      return { fromDate: null, toDate: null, filterType: "between" };
    } catch {
      return { fromDate: null, toDate: null, filterType: "between" };
    }
  });

  // Sauvegarde des états dans localStorage
  useEffect(() => {
    localStorage.setItem("sortField_lots", sortField);
    localStorage.setItem("sortOrder_lots", sortOrder);
  }, [sortField, sortOrder]);

  useEffect(() => {
    localStorage.setItem("dateRangeFilter_lots", JSON.stringify(dateRangeFilter));
  }, [dateRangeFilter]);

  useEffect(() => {
    localStorage.setItem("currentPage_lots", currentPage);
  }, [currentPage]);

  return {
    currentPage,
    setCurrentPage,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    dateRangeFilter,
    setDateRangeFilter,
  };
}
